import { isNumeric } from "../helpers/number_formatter_helper";

export const rxPassword = /^[\w!@#$%^&*()\-_=+[\]{};:'",.<>?/|\\~`]{6,18}$/;
export const rxSpace = /\s/g;
export const idPattern = /^[a-zA-Z0-9._@-]{6,24}$/;
export const rxNumberOnly = /^[0-9]+$/;
// export const idPattern = /^[a-zA-Z0-9](?:[a-zA-Z0-9_-]{6,28}[a-zA-Z0-9])?$/;
// export const rxNumberPermutation = /^(?:\d{1,3}(?:\*{1,2})?|--|---|\d{4,5}[-*]|\d{4,})(?!\d*\*\*)$/g;
export const rxNumberPermutation = /^(?!(?:\d{2,}\*\*|\d\*{3,}|\d{4,5}$))(?:(?:\d{1,3}(?:\*{1,2})?|--|---|\d{4,5}[-*]|\d{4,}))(?!\d*\*\*)$/g;
export const rxNumberCombination = /^(?:\d+(?:\*\d+)?|\*\d+)$/g;

export const multiplierSymbol = '*';
export const floatBettingSymbol = '-';
